/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessGuestBooking200,
  AccountDrivingContinuationInput,
  AccountDrivingHandoff,
  AccountDrivingProgress,
  AccountDrivingTrip,
  AcquisitionBindInput,
  AcquisitionSessionInput,
  AuthMeResponse,
  BacRequestActivityInput,
  BacRequestDocumentInput,
  BindAcquisitionSession200,
  BookingsListResponse,
  CarsFeaturedResponse,
  CarsMakeCountsResponse,
  CarsMakesResponse,
  CarsSearchResponse,
  CarsTypesResponse,
  CheckoutCapabilities,
  ClaimGuestCheckout200,
  ConfirmHostActivityActionBody,
  CreateAcquisitionSession200,
  DailyLandingInventory,
  DispatchHostActivityBatch200,
  DispatchHostActivityBatchBody,
  ErrorResponse,
  GetBookingHostHistoryDetail200,
  GetBookingQuoteParams,
  GetDailyLandingInventoryParams,
  GetGuestCheckout200,
  GetGuestCheckoutBookings200,
  GetHostActivityPreview200,
  GetHostActivityPreviewParams,
  GetHostActivityResultsParams,
  GetInitialRequestFinancialSnapshot200,
  GetLandingPageByPath200,
  GetLandingPageByPathParams,
  GetPublicCarCanonicals200,
  GetPublicCarCanonicalsParams,
  GetPublicHostActivity200,
  GetPublicHostActivityParams,
  GetPublicPageCanonical200,
  GetPublicPageCanonicalParams,
  GuestBookingAccessRequest,
  GuestCheckoutDetails,
  GuestCheckoutDraftDetails,
  HealthCheckParams,
  HealthStatus,
  HostActivityAudience,
  HostActivityDelivery,
  HostActivityResults,
  ListMostBookedNearbyCarsParams,
  ListSavedCarOfferInterests200,
  ListSavedCarOfferInterestsParams,
  ListingDraftInput,
  ListingDraftSingleResponse,
  ListingDraftsResponse,
  ListingReadiness,
  MessagesListResponse,
  MobileBackendIdentity,
  ObserveAcquisitionDocumentRequest200,
  PfcRecoveryDetails,
  PfcRecoveryEmailResult,
  PlanHostActivityBatch200,
  PlanHostActivityBatchBody,
  PlatformConfig,
  PriceQuote,
  PublicContentTranslation,
  PublicContentTranslationRequest,
  ReceiveHostActivityProviderEventsBody,
  RefreshAcquisitionRequestActivity200,
  SaveGuestCheckoutDraft200,
  SavedCarOfferConsent,
  SavedCarOfferConsentRequest,
  SavedCarOfferSendRequest,
  SearchCarsParams,
  SendSavedCarOffer200,
  StartGuestCheckout200,
  SuccessResponse,
  TestHostActivityEmailBody
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPfcPaymentRecoveryUrl = (publicId: string,) => {




  return `/api/checkout-sessions-pfc/${publicId}/recovery`
}

/**
 * @summary Restore the authenticated renter's server-owned checkout
 */
export const getPfcPaymentRecovery = async (publicId: string, options?: RequestInit): Promise<PfcRecoveryDetails> => {

  return customFetch<PfcRecoveryDetails>(getGetPfcPaymentRecoveryUrl(publicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPfcPaymentRecoveryQueryKey = (publicId: string,) => {
    return [
    `/api/checkout-sessions-pfc/${publicId}/recovery`
    ] as const;
    }


export const getGetPfcPaymentRecoveryQueryOptions = <TData = Awaited<ReturnType<typeof getPfcPaymentRecovery>>, TError = ErrorType<void>>(publicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPfcPaymentRecovery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPfcPaymentRecoveryQueryKey(publicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPfcPaymentRecovery>>> = ({ signal }) => getPfcPaymentRecovery(publicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: publicId !== null && publicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPfcPaymentRecovery>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPfcPaymentRecoveryQueryResult = NonNullable<Awaited<ReturnType<typeof getPfcPaymentRecovery>>>
export type GetPfcPaymentRecoveryQueryError = ErrorType<void>


/**
 * @summary Restore the authenticated renter's server-owned checkout
 */

export function useGetPfcPaymentRecovery<TData = Awaited<ReturnType<typeof getPfcPaymentRecovery>>, TError = ErrorType<void>>(
 publicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPfcPaymentRecovery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPfcPaymentRecoveryQueryOptions(publicId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEmailPfcPaymentRecoveryUrl = (publicId: string,) => {




  return `/api/checkout-sessions-pfc/${publicId}/recovery-email`
}

/**
 * @summary Email a secure authenticated continuation link without charging or extending holds
 */
export const emailPfcPaymentRecovery = async (publicId: string, options?: RequestInit): Promise<PfcRecoveryEmailResult> => {

  return customFetch<PfcRecoveryEmailResult>(getEmailPfcPaymentRecoveryUrl(publicId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEmailPfcPaymentRecoveryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailPfcPaymentRecovery>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailPfcPaymentRecovery>>, TError,{publicId: string}, TContext> => {

const mutationKey = ['emailPfcPaymentRecovery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailPfcPaymentRecovery>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  emailPfcPaymentRecovery(publicId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailPfcPaymentRecoveryMutationResult = NonNullable<Awaited<ReturnType<typeof emailPfcPaymentRecovery>>>

    export type EmailPfcPaymentRecoveryMutationError = ErrorType<void>

    /**
 * @summary Email a secure authenticated continuation link without charging or extending holds
 */
export const useEmailPfcPaymentRecovery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailPfcPaymentRecovery>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailPfcPaymentRecovery>>,
        TError,
        {publicId: string},
        TContext
      > => {
      return useMutation(getEmailPfcPaymentRecoveryMutationOptions(options));
    }

export const getGetHostActivityAudienceUrl = () => {




  return `/api/admin/host-activity/audience`
}

export const getHostActivityAudience = async ( options?: RequestInit): Promise<HostActivityAudience> => {

  return customFetch<HostActivityAudience>(getGetHostActivityAudienceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHostActivityAudienceQueryKey = () => {
    return [
    `/api/admin/host-activity/audience`
    ] as const;
    }


export const getGetHostActivityAudienceQueryOptions = <TData = Awaited<ReturnType<typeof getHostActivityAudience>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHostActivityAudienceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHostActivityAudience>>> = ({ signal }) => getHostActivityAudience({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHostActivityAudience>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHostActivityAudienceQueryResult = NonNullable<Awaited<ReturnType<typeof getHostActivityAudience>>>
export type GetHostActivityAudienceQueryError = ErrorType<unknown>



export function useGetHostActivityAudience<TData = Awaited<ReturnType<typeof getHostActivityAudience>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHostActivityAudienceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHostActivityPreviewUrl = (params: GetHostActivityPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/host-activity/preview?${stringifiedParams}` : `/api/admin/host-activity/preview`
}

export const getHostActivityPreview = async (params: GetHostActivityPreviewParams, options?: RequestInit): Promise<GetHostActivityPreview200> => {

  return customFetch<GetHostActivityPreview200>(getGetHostActivityPreviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHostActivityPreviewQueryKey = (params?: GetHostActivityPreviewParams,) => {
    return [
    `/api/admin/host-activity/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHostActivityPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getHostActivityPreview>>, TError = ErrorType<unknown>>(params: GetHostActivityPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHostActivityPreviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHostActivityPreview>>> = ({ signal }) => getHostActivityPreview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHostActivityPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHostActivityPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getHostActivityPreview>>>
export type GetHostActivityPreviewQueryError = ErrorType<unknown>



export function useGetHostActivityPreview<TData = Awaited<ReturnType<typeof getHostActivityPreview>>, TError = ErrorType<unknown>>(
 params: GetHostActivityPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHostActivityPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTestHostActivityEmailUrl = () => {




  return `/api/admin/host-activity/test`
}

export const testHostActivityEmail = async (testHostActivityEmailBody: TestHostActivityEmailBody, options?: RequestInit): Promise<HostActivityDelivery> => {

  return customFetch<HostActivityDelivery>(getTestHostActivityEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(testHostActivityEmailBody)
  }
);}





export const getTestHostActivityEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testHostActivityEmail>>, TError,{data: BodyType<TestHostActivityEmailBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testHostActivityEmail>>, TError,{data: BodyType<TestHostActivityEmailBody>}, TContext> => {

const mutationKey = ['testHostActivityEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testHostActivityEmail>>, {data: BodyType<TestHostActivityEmailBody>}> = (props) => {
          const {data} = props ?? {};

          return  testHostActivityEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestHostActivityEmailMutationResult = NonNullable<Awaited<ReturnType<typeof testHostActivityEmail>>>
    export type TestHostActivityEmailMutationBody = BodyType<TestHostActivityEmailBody>
    export type TestHostActivityEmailMutationError = ErrorType<void>

    export const useTestHostActivityEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testHostActivityEmail>>, TError,{data: BodyType<TestHostActivityEmailBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testHostActivityEmail>>,
        TError,
        {data: BodyType<TestHostActivityEmailBody>},
        TContext
      > => {
      return useMutation(getTestHostActivityEmailMutationOptions(options));
    }

export const getPlanHostActivityBatchUrl = () => {




  return `/api/admin/host-activity/batches`
}

export const planHostActivityBatch = async (planHostActivityBatchBody: PlanHostActivityBatchBody, options?: RequestInit): Promise<PlanHostActivityBatch200> => {

  return customFetch<PlanHostActivityBatch200>(getPlanHostActivityBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(planHostActivityBatchBody)
  }
);}





export const getPlanHostActivityBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planHostActivityBatch>>, TError,{data: BodyType<PlanHostActivityBatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof planHostActivityBatch>>, TError,{data: BodyType<PlanHostActivityBatchBody>}, TContext> => {

const mutationKey = ['planHostActivityBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planHostActivityBatch>>, {data: BodyType<PlanHostActivityBatchBody>}> = (props) => {
          const {data} = props ?? {};

          return  planHostActivityBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlanHostActivityBatchMutationResult = NonNullable<Awaited<ReturnType<typeof planHostActivityBatch>>>
    export type PlanHostActivityBatchMutationBody = BodyType<PlanHostActivityBatchBody>
    export type PlanHostActivityBatchMutationError = ErrorType<unknown>

    export const usePlanHostActivityBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planHostActivityBatch>>, TError,{data: BodyType<PlanHostActivityBatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof planHostActivityBatch>>,
        TError,
        {data: BodyType<PlanHostActivityBatchBody>},
        TContext
      > => {
      return useMutation(getPlanHostActivityBatchMutationOptions(options));
    }

export const getDispatchHostActivityBatchUrl = (id: string,) => {




  return `/api/admin/host-activity/batches/${id}/send`
}

export const dispatchHostActivityBatch = async (id: string,
    dispatchHostActivityBatchBody: DispatchHostActivityBatchBody, options?: RequestInit): Promise<DispatchHostActivityBatch200> => {

  return customFetch<DispatchHostActivityBatch200>(getDispatchHostActivityBatchUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dispatchHostActivityBatchBody)
  }
);}





export const getDispatchHostActivityBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dispatchHostActivityBatch>>, TError,{id: string;data: BodyType<DispatchHostActivityBatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dispatchHostActivityBatch>>, TError,{id: string;data: BodyType<DispatchHostActivityBatchBody>}, TContext> => {

const mutationKey = ['dispatchHostActivityBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dispatchHostActivityBatch>>, {id: string;data: BodyType<DispatchHostActivityBatchBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  dispatchHostActivityBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DispatchHostActivityBatchMutationResult = NonNullable<Awaited<ReturnType<typeof dispatchHostActivityBatch>>>
    export type DispatchHostActivityBatchMutationBody = BodyType<DispatchHostActivityBatchBody>
    export type DispatchHostActivityBatchMutationError = ErrorType<unknown>

    export const useDispatchHostActivityBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dispatchHostActivityBatch>>, TError,{id: string;data: BodyType<DispatchHostActivityBatchBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dispatchHostActivityBatch>>,
        TError,
        {id: string;data: BodyType<DispatchHostActivityBatchBody>},
        TContext
      > => {
      return useMutation(getDispatchHostActivityBatchMutationOptions(options));
    }

export const getGetHostActivityResultsUrl = (params?: GetHostActivityResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/host-activity/results?${stringifiedParams}` : `/api/admin/host-activity/results`
}

export const getHostActivityResults = async (params?: GetHostActivityResultsParams, options?: RequestInit): Promise<HostActivityResults> => {

  return customFetch<HostActivityResults>(getGetHostActivityResultsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHostActivityResultsQueryKey = (params?: GetHostActivityResultsParams,) => {
    return [
    `/api/admin/host-activity/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHostActivityResultsQueryOptions = <TData = Awaited<ReturnType<typeof getHostActivityResults>>, TError = ErrorType<unknown>>(params?: GetHostActivityResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHostActivityResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHostActivityResults>>> = ({ signal }) => getHostActivityResults(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHostActivityResults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHostActivityResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getHostActivityResults>>>
export type GetHostActivityResultsQueryError = ErrorType<unknown>



export function useGetHostActivityResults<TData = Awaited<ReturnType<typeof getHostActivityResults>>, TError = ErrorType<unknown>>(
 params?: GetHostActivityResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostActivityResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHostActivityResultsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicHostActivityUrl = (params: GetPublicHostActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cars/host-activity-status?${stringifiedParams}` : `/api/cars/host-activity-status`
}

export const getPublicHostActivity = async (params: GetPublicHostActivityParams, options?: RequestInit): Promise<GetPublicHostActivity200> => {

  return customFetch<GetPublicHostActivity200>(getGetPublicHostActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicHostActivityQueryKey = (params?: GetPublicHostActivityParams,) => {
    return [
    `/api/cars/host-activity-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicHostActivityQueryOptions = <TData = Awaited<ReturnType<typeof getPublicHostActivity>>, TError = ErrorType<unknown>>(params: GetPublicHostActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicHostActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicHostActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicHostActivity>>> = ({ signal }) => getPublicHostActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicHostActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicHostActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicHostActivity>>>
export type GetPublicHostActivityQueryError = ErrorType<unknown>



export function useGetPublicHostActivity<TData = Awaited<ReturnType<typeof getPublicHostActivity>>, TError = ErrorType<unknown>>(
 params: GetPublicHostActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicHostActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicHostActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getViewHostActivityActionUrl = (purpose: 'confirm' | 'pause' | 'sold',
    token: string,) => {




  return `/api/host-activity/${purpose}/${token}`
}

export const viewHostActivityAction = async (purpose: 'confirm' | 'pause' | 'sold',
    token: string, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getViewHostActivityActionUrl(purpose,token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getViewHostActivityActionQueryKey = (purpose: 'confirm' | 'pause' | 'sold',
    token: string,) => {
    return [
    `/api/host-activity/${purpose}/${token}`
    ] as const;
    }


export const getViewHostActivityActionQueryOptions = <TData = Awaited<ReturnType<typeof viewHostActivityAction>>, TError = ErrorType<void>>(purpose: 'confirm' | 'pause' | 'sold',
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewHostActivityAction>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewHostActivityActionQueryKey(purpose,token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewHostActivityAction>>> = ({ signal }) => viewHostActivityAction(purpose,token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: purpose !== null && purpose !== undefined && token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewHostActivityAction>>, TError, TData> & { queryKey: QueryKey }
}

export type ViewHostActivityActionQueryResult = NonNullable<Awaited<ReturnType<typeof viewHostActivityAction>>>
export type ViewHostActivityActionQueryError = ErrorType<void>



export function useViewHostActivityAction<TData = Awaited<ReturnType<typeof viewHostActivityAction>>, TError = ErrorType<void>>(
 purpose: 'confirm' | 'pause' | 'sold',
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof viewHostActivityAction>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getViewHostActivityActionQueryOptions(purpose,token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConfirmHostActivityActionUrl = (purpose: 'confirm' | 'pause' | 'sold',
    token: string,) => {




  return `/api/host-activity/${purpose}/${token}`
}

export const confirmHostActivityAction = async (purpose: 'confirm' | 'pause' | 'sold',
    token: string,
    confirmHostActivityActionBody: ConfirmHostActivityActionBody, options?: RequestInit): Promise<string> => {
    const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append(`human_confirmation`, confirmHostActivityActionBody.human_confirmation);
if(confirmHostActivityActionBody.car_ids !== undefined) {
 confirmHostActivityActionBody.car_ids.forEach(value => formUrlEncoded.append(`car_ids`, value.toString()));
 }

  return customFetch<string>(getConfirmHostActivityActionUrl(purpose,token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
    body: formUrlEncoded
  }
);}





export const getConfirmHostActivityActionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmHostActivityAction>>, TError,{purpose: 'confirm' | 'pause' | 'sold';token: string;data: BodyType<ConfirmHostActivityActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmHostActivityAction>>, TError,{purpose: 'confirm' | 'pause' | 'sold';token: string;data: BodyType<ConfirmHostActivityActionBody>}, TContext> => {

const mutationKey = ['confirmHostActivityAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmHostActivityAction>>, {purpose: 'confirm' | 'pause' | 'sold';token: string;data: BodyType<ConfirmHostActivityActionBody>}> = (props) => {
          const {purpose,token,data} = props ?? {};

          return  confirmHostActivityAction(purpose,token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmHostActivityActionMutationResult = NonNullable<Awaited<ReturnType<typeof confirmHostActivityAction>>>
    export type ConfirmHostActivityActionMutationBody = BodyType<ConfirmHostActivityActionBody>
    export type ConfirmHostActivityActionMutationError = ErrorType<void>

    export const useConfirmHostActivityAction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmHostActivityAction>>, TError,{purpose: 'confirm' | 'pause' | 'sold';token: string;data: BodyType<ConfirmHostActivityActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmHostActivityAction>>,
        TError,
        {purpose: 'confirm' | 'pause' | 'sold';token: string;data: BodyType<ConfirmHostActivityActionBody>},
        TContext
      > => {
      return useMutation(getConfirmHostActivityActionMutationOptions(options));
    }

export const getReceiveHostActivityProviderEventsUrl = () => {




  return `/api/webhooks/mailtrap/host-activity`
}

export const receiveHostActivityProviderEvents = async (receiveHostActivityProviderEventsBody: ReceiveHostActivityProviderEventsBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getReceiveHostActivityProviderEventsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(receiveHostActivityProviderEventsBody)
  }
);}





export const getReceiveHostActivityProviderEventsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>, TError,{data: BodyType<ReceiveHostActivityProviderEventsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>, TError,{data: BodyType<ReceiveHostActivityProviderEventsBody>}, TContext> => {

const mutationKey = ['receiveHostActivityProviderEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>, {data: BodyType<ReceiveHostActivityProviderEventsBody>}> = (props) => {
          const {data} = props ?? {};

          return  receiveHostActivityProviderEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveHostActivityProviderEventsMutationResult = NonNullable<Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>>
    export type ReceiveHostActivityProviderEventsMutationBody = BodyType<ReceiveHostActivityProviderEventsBody>
    export type ReceiveHostActivityProviderEventsMutationError = ErrorType<void>

    export const useReceiveHostActivityProviderEvents = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>, TError,{data: BodyType<ReceiveHostActivityProviderEventsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof receiveHostActivityProviderEvents>>,
        TError,
        {data: BodyType<ReceiveHostActivityProviderEventsBody>},
        TContext
      > => {
      return useMutation(getReceiveHostActivityProviderEventsMutationOptions(options));
    }

export const getGetCheckoutCapabilitiesUrl = () => {




  return `/api/users/me/checkout-capabilities`
}

export const getCheckoutCapabilities = async ( options?: RequestInit): Promise<CheckoutCapabilities> => {

  return customFetch<CheckoutCapabilities>(getGetCheckoutCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCheckoutCapabilitiesQueryKey = () => {
    return [
    `/api/users/me/checkout-capabilities`
    ] as const;
    }


export const getGetCheckoutCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getCheckoutCapabilities>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCheckoutCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCheckoutCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCheckoutCapabilities>>> = ({ signal }) => getCheckoutCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCheckoutCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCheckoutCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getCheckoutCapabilities>>>
export type GetCheckoutCapabilitiesQueryError = ErrorType<void>



export function useGetCheckoutCapabilities<TData = Awaited<ReturnType<typeof getCheckoutCapabilities>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCheckoutCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCheckoutCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetListingReadinessUrl = (id: number,) => {




  return `/api/listings/${id}/readiness`
}

export const getListingReadiness = async (id: number, options?: RequestInit): Promise<ListingReadiness> => {

  return customFetch<ListingReadiness>(getGetListingReadinessUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetListingReadinessQueryKey = (id: number,) => {
    return [
    `/api/listings/${id}/readiness`
    ] as const;
    }


export const getGetListingReadinessQueryOptions = <TData = Awaited<ReturnType<typeof getListingReadiness>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingReadinessQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingReadiness>>> = ({ signal }) => getListingReadiness(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingReadiness>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof getListingReadiness>>>
export type GetListingReadinessQueryError = ErrorType<void>



export function useGetListingReadiness<TData = Awaited<ReturnType<typeof getListingReadiness>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingReadinessQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBookingHostHistoryDetailUrl = (publicId: string,) => {




  return `/api/bookings/${publicId}`
}

export const getBookingHostHistoryDetail = async (publicId: string, options?: RequestInit): Promise<GetBookingHostHistoryDetail200> => {

  return customFetch<GetBookingHostHistoryDetail200>(getGetBookingHostHistoryDetailUrl(publicId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBookingHostHistoryDetailQueryKey = (publicId: string,) => {
    return [
    `/api/bookings/${publicId}`
    ] as const;
    }


export const getGetBookingHostHistoryDetailQueryOptions = <TData = Awaited<ReturnType<typeof getBookingHostHistoryDetail>>, TError = ErrorType<unknown>>(publicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBookingHostHistoryDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingHostHistoryDetailQueryKey(publicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingHostHistoryDetail>>> = ({ signal }) => getBookingHostHistoryDetail(publicId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: publicId !== null && publicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingHostHistoryDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBookingHostHistoryDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingHostHistoryDetail>>>
export type GetBookingHostHistoryDetailQueryError = ErrorType<unknown>



export function useGetBookingHostHistoryDetail<TData = Awaited<ReturnType<typeof getBookingHostHistoryDetail>>, TError = ErrorType<unknown>>(
 publicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBookingHostHistoryDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBookingHostHistoryDetailQueryOptions(publicId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getObserveAcquisitionDocumentRequestUrl = () => {




  return `/api/acquisition/request-document`
}

/**
 * @summary Internal BAC first-document handoff; production activation disabled
 */
export const observeAcquisitionDocumentRequest = async (bacRequestDocumentInput: BacRequestDocumentInput, options?: RequestInit): Promise<ObserveAcquisitionDocumentRequest200> => {

  return customFetch<ObserveAcquisitionDocumentRequest200>(getObserveAcquisitionDocumentRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bacRequestDocumentInput)
  }
);}





export const getObserveAcquisitionDocumentRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>, TError,{data: BodyType<BacRequestDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>, TError,{data: BodyType<BacRequestDocumentInput>}, TContext> => {

const mutationKey = ['observeAcquisitionDocumentRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>, {data: BodyType<BacRequestDocumentInput>}> = (props) => {
          const {data} = props ?? {};

          return  observeAcquisitionDocumentRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ObserveAcquisitionDocumentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>>
    export type ObserveAcquisitionDocumentRequestMutationBody = BodyType<BacRequestDocumentInput>
    export type ObserveAcquisitionDocumentRequestMutationError = ErrorType<void>

    /**
 * @summary Internal BAC first-document handoff; production activation disabled
 */
export const useObserveAcquisitionDocumentRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>, TError,{data: BodyType<BacRequestDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof observeAcquisitionDocumentRequest>>,
        TError,
        {data: BodyType<BacRequestDocumentInput>},
        TContext
      > => {
      return useMutation(getObserveAcquisitionDocumentRequestMutationOptions(options));
    }

export const getRefreshAcquisitionRequestActivityUrl = () => {




  return `/api/acquisition/request-activity`
}

/**
 * @summary Renew an existing signed BAC request session without inventing an arrival
 */
export const refreshAcquisitionRequestActivity = async (bacRequestActivityInput?: BacRequestActivityInput, options?: RequestInit): Promise<RefreshAcquisitionRequestActivity200> => {

  return customFetch<RefreshAcquisitionRequestActivity200>(getRefreshAcquisitionRequestActivityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bacRequestActivityInput)
  }
);}





export const getRefreshAcquisitionRequestActivityMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>, TError,{data?: BodyType<BacRequestActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>, TError,{data?: BodyType<BacRequestActivityInput>}, TContext> => {

const mutationKey = ['refreshAcquisitionRequestActivity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>, {data?: BodyType<BacRequestActivityInput>}> = (props) => {
          const {data} = props ?? {};

          return  refreshAcquisitionRequestActivity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshAcquisitionRequestActivityMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>>
    export type RefreshAcquisitionRequestActivityMutationBody = BodyType<BacRequestActivityInput> | undefined
    export type RefreshAcquisitionRequestActivityMutationError = ErrorType<void>

    /**
 * @summary Renew an existing signed BAC request session without inventing an arrival
 */
export const useRefreshAcquisitionRequestActivity = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>, TError,{data?: BodyType<BacRequestActivityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshAcquisitionRequestActivity>>,
        TError,
        {data?: BodyType<BacRequestActivityInput>},
        TContext
      > => {
      return useMutation(getRefreshAcquisitionRequestActivityMutationOptions(options));
    }

export const getCreateAcquisitionSessionUrl = () => {




  return `/api/acquisition/session`
}

/**
 * @summary Optional BAC consented acquisition handoff (private uncached response)
 */
export const createAcquisitionSession = async (acquisitionSessionInput: AcquisitionSessionInput, options?: RequestInit): Promise<CreateAcquisitionSession200> => {

  return customFetch<CreateAcquisitionSession200>(getCreateAcquisitionSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acquisitionSessionInput)
  }
);}





export const getCreateAcquisitionSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAcquisitionSession>>, TError,{data: BodyType<AcquisitionSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAcquisitionSession>>, TError,{data: BodyType<AcquisitionSessionInput>}, TContext> => {

const mutationKey = ['createAcquisitionSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAcquisitionSession>>, {data: BodyType<AcquisitionSessionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAcquisitionSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAcquisitionSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createAcquisitionSession>>>
    export type CreateAcquisitionSessionMutationBody = BodyType<AcquisitionSessionInput>
    export type CreateAcquisitionSessionMutationError = ErrorType<void>

    /**
 * @summary Optional BAC consented acquisition handoff (private uncached response)
 */
export const useCreateAcquisitionSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAcquisitionSession>>, TError,{data: BodyType<AcquisitionSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAcquisitionSession>>,
        TError,
        {data: BodyType<AcquisitionSessionInput>},
        TContext
      > => {
      return useMutation(getCreateAcquisitionSessionMutationOptions(options));
    }

export const getBindAcquisitionSessionUrl = () => {




  return `/api/acquisition/bind`
}

/**
 * @summary Bind consented signed state to authenticated renter
 */
export const bindAcquisitionSession = async (acquisitionBindInput?: AcquisitionBindInput, options?: RequestInit): Promise<BindAcquisitionSession200> => {

  return customFetch<BindAcquisitionSession200>(getBindAcquisitionSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acquisitionBindInput)
  }
);}





export const getBindAcquisitionSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bindAcquisitionSession>>, TError,{data?: BodyType<AcquisitionBindInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bindAcquisitionSession>>, TError,{data?: BodyType<AcquisitionBindInput>}, TContext> => {

const mutationKey = ['bindAcquisitionSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bindAcquisitionSession>>, {data?: BodyType<AcquisitionBindInput>}> = (props) => {
          const {data} = props ?? {};

          return  bindAcquisitionSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BindAcquisitionSessionMutationResult = NonNullable<Awaited<ReturnType<typeof bindAcquisitionSession>>>
    export type BindAcquisitionSessionMutationBody = BodyType<AcquisitionBindInput> | undefined
    export type BindAcquisitionSessionMutationError = ErrorType<void>

    /**
 * @summary Bind consented signed state to authenticated renter
 */
export const useBindAcquisitionSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bindAcquisitionSession>>, TError,{data?: BodyType<AcquisitionBindInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bindAcquisitionSession>>,
        TError,
        {data?: BodyType<AcquisitionBindInput>},
        TContext
      > => {
      return useMutation(getBindAcquisitionSessionMutationOptions(options));
    }

export const getGetPublicCarCanonicalsUrl = (params: GetPublicCarCanonicalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public-canonical/cars?${stringifiedParams}` : `/api/public-canonical/cars`
}

export const getPublicCarCanonicals = async (params: GetPublicCarCanonicalsParams, options?: RequestInit): Promise<GetPublicCarCanonicals200> => {

  return customFetch<GetPublicCarCanonicals200>(getGetPublicCarCanonicalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicCarCanonicalsQueryKey = (params?: GetPublicCarCanonicalsParams,) => {
    return [
    `/api/public-canonical/cars`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicCarCanonicalsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCarCanonicals>>, TError = ErrorType<void>>(params: GetPublicCarCanonicalsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicCarCanonicals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCarCanonicalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCarCanonicals>>> = ({ signal }) => getPublicCarCanonicals(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCarCanonicals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicCarCanonicalsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCarCanonicals>>>
export type GetPublicCarCanonicalsQueryError = ErrorType<void>



export function useGetPublicCarCanonicals<TData = Awaited<ReturnType<typeof getPublicCarCanonicals>>, TError = ErrorType<void>>(
 params: GetPublicCarCanonicalsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicCarCanonicals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicCarCanonicalsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicPageCanonicalUrl = (params: GetPublicPageCanonicalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public-canonical/page?${stringifiedParams}` : `/api/public-canonical/page`
}

export const getPublicPageCanonical = async (params: GetPublicPageCanonicalParams, options?: RequestInit): Promise<GetPublicPageCanonical200> => {

  return customFetch<GetPublicPageCanonical200>(getGetPublicPageCanonicalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPageCanonicalQueryKey = (params?: GetPublicPageCanonicalParams,) => {
    return [
    `/api/public-canonical/page`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicPageCanonicalQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPageCanonical>>, TError = ErrorType<void>>(params: GetPublicPageCanonicalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPageCanonical>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPageCanonicalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPageCanonical>>> = ({ signal }) => getPublicPageCanonical(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPageCanonical>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicPageCanonicalQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPageCanonical>>>
export type GetPublicPageCanonicalQueryError = ErrorType<void>



export function useGetPublicPageCanonical<TData = Awaited<ReturnType<typeof getPublicPageCanonical>>, TError = ErrorType<void>>(
 params: GetPublicPageCanonicalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPageCanonical>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicPageCanonicalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountDrivingTripsUrl = () => {




  return `/api/bookings/my-driving`
}

/**
 * @summary Read-only accepted account driving trips
 */
export const getAccountDrivingTrips = async ( options?: RequestInit): Promise<AccountDrivingTrip[]> => {

  return customFetch<AccountDrivingTrip[]>(getGetAccountDrivingTripsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountDrivingTripsQueryKey = () => {
    return [
    `/api/bookings/my-driving`
    ] as const;
    }


export const getGetAccountDrivingTripsQueryOptions = <TData = Awaited<ReturnType<typeof getAccountDrivingTrips>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingTrips>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountDrivingTripsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountDrivingTrips>>> = ({ signal }) => getAccountDrivingTrips({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingTrips>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountDrivingTripsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountDrivingTrips>>>
export type GetAccountDrivingTripsQueryError = ErrorType<void>


/**
 * @summary Read-only accepted account driving trips
 */

export function useGetAccountDrivingTrips<TData = Awaited<ReturnType<typeof getAccountDrivingTrips>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingTrips>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountDrivingTripsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountDrivingAssessmentUrl = (assignmentId: string,) => {




  return `/api/bookings/driving-assignments/${assignmentId}/assessment`
}

/**
 * @summary Provider-free assessment of an authenticated accepted assignment
 */
export const getAccountDrivingAssessment = async (assignmentId: string, options?: RequestInit): Promise<AccountDrivingProgress> => {

  return customFetch<AccountDrivingProgress>(getGetAccountDrivingAssessmentUrl(assignmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountDrivingAssessmentQueryKey = (assignmentId: string,) => {
    return [
    `/api/bookings/driving-assignments/${assignmentId}/assessment`
    ] as const;
    }


export const getGetAccountDrivingAssessmentQueryOptions = <TData = Awaited<ReturnType<typeof getAccountDrivingAssessment>>, TError = ErrorType<void>>(assignmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountDrivingAssessmentQueryKey(assignmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountDrivingAssessment>>> = ({ signal }) => getAccountDrivingAssessment(assignmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: assignmentId !== null && assignmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingAssessment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountDrivingAssessmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountDrivingAssessment>>>
export type GetAccountDrivingAssessmentQueryError = ErrorType<void>


/**
 * @summary Provider-free assessment of an authenticated accepted assignment
 */

export function useGetAccountDrivingAssessment<TData = Awaited<ReturnType<typeof getAccountDrivingAssessment>>, TError = ErrorType<void>>(
 assignmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDrivingAssessment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountDrivingAssessmentQueryOptions(assignmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getContinueAccountDrivingChecksUrl = (assignmentId: string,) => {




  return `/api/bookings/driving-assignments/${assignmentId}/continue`
}

/**
 * @summary Explicit assignment-bound start or continuation without invitation tokens
 */
export const continueAccountDrivingChecks = async (assignmentId: string,
    accountDrivingContinuationInput: AccountDrivingContinuationInput, options?: RequestInit): Promise<AccountDrivingHandoff> => {

  return customFetch<AccountDrivingHandoff>(getContinueAccountDrivingChecksUrl(assignmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountDrivingContinuationInput)
  }
);}





export const getContinueAccountDrivingChecksMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueAccountDrivingChecks>>, TError,{assignmentId: string;data: BodyType<AccountDrivingContinuationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof continueAccountDrivingChecks>>, TError,{assignmentId: string;data: BodyType<AccountDrivingContinuationInput>}, TContext> => {

const mutationKey = ['continueAccountDrivingChecks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof continueAccountDrivingChecks>>, {assignmentId: string;data: BodyType<AccountDrivingContinuationInput>}> = (props) => {
          const {assignmentId,data} = props ?? {};

          return  continueAccountDrivingChecks(assignmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ContinueAccountDrivingChecksMutationResult = NonNullable<Awaited<ReturnType<typeof continueAccountDrivingChecks>>>
    export type ContinueAccountDrivingChecksMutationBody = BodyType<AccountDrivingContinuationInput>
    export type ContinueAccountDrivingChecksMutationError = ErrorType<void>

    /**
 * @summary Explicit assignment-bound start or continuation without invitation tokens
 */
export const useContinueAccountDrivingChecks = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueAccountDrivingChecks>>, TError,{assignmentId: string;data: BodyType<AccountDrivingContinuationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof continueAccountDrivingChecks>>,
        TError,
        {assignmentId: string;data: BodyType<AccountDrivingContinuationInput>},
        TContext
      > => {
      return useMutation(getContinueAccountDrivingChecksMutationOptions(options));
    }

export const getGetMobileBackendIdentityUrl = () => {




  return `/api/backend-identity`
}

/**
 * Public project identifiers only; development requires matching effective auth, catalogue and direct database targets. Never use hostname naming as environment proof.
 * @summary Effective mobile backend environment identity
 */
export const getMobileBackendIdentity = async ( options?: RequestInit): Promise<MobileBackendIdentity> => {

  return customFetch<MobileBackendIdentity>(getGetMobileBackendIdentityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileBackendIdentityQueryKey = () => {
    return [
    `/api/backend-identity`
    ] as const;
    }


export const getGetMobileBackendIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getMobileBackendIdentity>>, TError = ErrorType<MobileBackendIdentity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileBackendIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileBackendIdentityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileBackendIdentity>>> = ({ signal }) => getMobileBackendIdentity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileBackendIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileBackendIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileBackendIdentity>>>
export type GetMobileBackendIdentityQueryError = ErrorType<MobileBackendIdentity>


/**
 * @summary Effective mobile backend environment identity
 */

export function useGetMobileBackendIdentity<TData = Awaited<ReturnType<typeof getMobileBackendIdentity>>, TError = ErrorType<MobileBackendIdentity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileBackendIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileBackendIdentityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthCheckUrl = (params?: HealthCheckParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/healthz?${stringifiedParams}` : `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async (params?: HealthCheckParams, options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = (params?: HealthCheckParams,) => {
    return [
    `/api/healthz`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(params?: HealthCheckParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
 params?: HealthCheckParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLandingPageByPathUrl = (params: GetLandingPageByPathParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/landing-pages/by-path?${stringifiedParams}` : `/api/landing-pages/by-path`
}

/**
 * @summary Resolve a public landing page by its requested path
 */
export const getLandingPageByPath = async (params: GetLandingPageByPathParams, options?: RequestInit): Promise<GetLandingPageByPath200> => {

  return customFetch<GetLandingPageByPath200>(getGetLandingPageByPathUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLandingPageByPathQueryKey = (params?: GetLandingPageByPathParams,) => {
    return [
    `/api/landing-pages/by-path`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLandingPageByPathQueryOptions = <TData = Awaited<ReturnType<typeof getLandingPageByPath>>, TError = ErrorType<ErrorResponse>>(params: GetLandingPageByPathParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLandingPageByPath>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLandingPageByPathQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLandingPageByPath>>> = ({ signal }) => getLandingPageByPath(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLandingPageByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLandingPageByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getLandingPageByPath>>>
export type GetLandingPageByPathQueryError = ErrorType<ErrorResponse>


/**
 * @summary Resolve a public landing page by its requested path
 */

export function useGetLandingPageByPath<TData = Awaited<ReturnType<typeof getLandingPageByPath>>, TError = ErrorType<ErrorResponse>>(
 params: GetLandingPageByPathParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLandingPageByPath>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLandingPageByPathQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPlatformConfigUrl = () => {




  return `/api/config/platform`
}

/**
 * Returns currency formatting rules, cancellation policies, and verification requirements
 * @summary Get platform configuration
 */
export const getPlatformConfig = async ( options?: RequestInit): Promise<PlatformConfig> => {

  return customFetch<PlatformConfig>(getGetPlatformConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformConfigQueryKey = () => {
    return [
    `/api/config/platform`
    ] as const;
    }


export const getGetPlatformConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformConfig>>> = ({ signal }) => getPlatformConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformConfig>>>
export type GetPlatformConfigQueryError = ErrorType<unknown>


/**
 * @summary Get platform configuration
 */

export function useGetPlatformConfig<TData = Awaited<ReturnType<typeof getPlatformConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDailyLandingInventoryUrl = (params: GetDailyLandingInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/landing-pages/fixed-inventory?${stringifiedParams}` : `/api/landing-pages/fixed-inventory`
}

/**
 * Returns the same immutable, ordered car-card cohorts used by landing-page rendering. Search results and booking availability remain live.
 * @summary Get the published daily car selection for a marketing landing page
 */
export const getDailyLandingInventory = async (params: GetDailyLandingInventoryParams, options?: RequestInit): Promise<DailyLandingInventory> => {

  return customFetch<DailyLandingInventory>(getGetDailyLandingInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDailyLandingInventoryQueryKey = (params?: GetDailyLandingInventoryParams,) => {
    return [
    `/api/landing-pages/fixed-inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDailyLandingInventoryQueryOptions = <TData = Awaited<ReturnType<typeof getDailyLandingInventory>>, TError = ErrorType<ErrorResponse>>(params: GetDailyLandingInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyLandingInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyLandingInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyLandingInventory>>> = ({ signal }) => getDailyLandingInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyLandingInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDailyLandingInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyLandingInventory>>>
export type GetDailyLandingInventoryQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get the published daily car selection for a marketing landing page
 */

export function useGetDailyLandingInventory<TData = Awaited<ReturnType<typeof getDailyLandingInventory>>, TError = ErrorType<ErrorResponse>>(
 params: GetDailyLandingInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyLandingInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDailyLandingInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBookingQuoteUrl = (params: GetBookingQuoteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings/quote?${stringifiedParams}` : `/api/bookings/quote`
}

/**
 * Calculates pricing for a car rental including fees, insurance, and cancellation discounts
 * @summary Get a booking price quote
 */
export const getBookingQuote = async (params: GetBookingQuoteParams, options?: RequestInit): Promise<PriceQuote> => {

  return customFetch<PriceQuote>(getGetBookingQuoteUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBookingQuoteQueryKey = (params?: GetBookingQuoteParams,) => {
    return [
    `/api/bookings/quote`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBookingQuoteQueryOptions = <TData = Awaited<ReturnType<typeof getBookingQuote>>, TError = ErrorType<ErrorResponse>>(params: GetBookingQuoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBookingQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingQuoteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingQuote>>> = ({ signal }) => getBookingQuote(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingQuote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBookingQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingQuote>>>
export type GetBookingQuoteQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a booking price quote
 */

export function useGetBookingQuote<TData = Awaited<ReturnType<typeof getBookingQuote>>, TError = ErrorType<ErrorResponse>>(
 params: GetBookingQuoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBookingQuote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBookingQuoteQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListListingDraftsUrl = () => {




  return `/api/listings/drafts`
}

/**
 * Returns all listing drafts for the authenticated user
 * @summary List listing drafts
 */
export const listListingDrafts = async ( options?: RequestInit): Promise<ListingDraftsResponse> => {

  return customFetch<ListingDraftsResponse>(getListListingDraftsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListListingDraftsQueryKey = () => {
    return [
    `/api/listings/drafts`
    ] as const;
    }


export const getListListingDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listListingDrafts>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listListingDrafts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListListingDraftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listListingDrafts>>> = ({ signal }) => listListingDrafts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listListingDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListListingDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listListingDrafts>>>
export type ListListingDraftsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List listing drafts
 */

export function useListListingDrafts<TData = Awaited<ReturnType<typeof listListingDrafts>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listListingDrafts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListListingDraftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateListingDraftUrl = () => {




  return `/api/listings/drafts`
}

/**
 * Saves a new listing wizard draft for the authenticated user
 * @summary Create a listing draft
 */
export const createListingDraft = async (listingDraftInput: ListingDraftInput, options?: RequestInit): Promise<ListingDraftSingleResponse> => {

  return customFetch<ListingDraftSingleResponse>(getCreateListingDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingDraftInput)
  }
);}





export const getCreateListingDraftMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListingDraft>>, TError,{data: BodyType<ListingDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createListingDraft>>, TError,{data: BodyType<ListingDraftInput>}, TContext> => {

const mutationKey = ['createListingDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createListingDraft>>, {data: BodyType<ListingDraftInput>}> = (props) => {
          const {data} = props ?? {};

          return  createListingDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateListingDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createListingDraft>>>
    export type CreateListingDraftMutationBody = BodyType<ListingDraftInput>
    export type CreateListingDraftMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a listing draft
 */
export const useCreateListingDraft = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListingDraft>>, TError,{data: BodyType<ListingDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createListingDraft>>,
        TError,
        {data: BodyType<ListingDraftInput>},
        TContext
      > => {
      return useMutation(getCreateListingDraftMutationOptions(options));
    }

export const getGetListingDraftUrl = (id: string,) => {




  return `/api/listings/drafts/${id}`
}

/**
 * Returns a specific listing draft by ID for the authenticated user
 * @summary Get a listing draft
 */
export const getListingDraft = async (id: string, options?: RequestInit): Promise<ListingDraftSingleResponse> => {

  return customFetch<ListingDraftSingleResponse>(getGetListingDraftUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetListingDraftQueryKey = (id: string,) => {
    return [
    `/api/listings/drafts/${id}`
    ] as const;
    }


export const getGetListingDraftQueryOptions = <TData = Awaited<ReturnType<typeof getListingDraft>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingDraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingDraft>>> = ({ signal }) => getListingDraft(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getListingDraft>>>
export type GetListingDraftQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a listing draft
 */

export function useGetListingDraft<TData = Awaited<ReturnType<typeof getListingDraft>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingDraftQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateListingDraftUrl = (id: string,) => {




  return `/api/listings/drafts/${id}`
}

/**
 * Updates an existing listing draft
 * @summary Update a listing draft
 */
export const updateListingDraft = async (id: string,
    listingDraftInput: ListingDraftInput, options?: RequestInit): Promise<ListingDraftSingleResponse> => {

  return customFetch<ListingDraftSingleResponse>(getUpdateListingDraftUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingDraftInput)
  }
);}





export const getUpdateListingDraftMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListingDraft>>, TError,{id: string;data: BodyType<ListingDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateListingDraft>>, TError,{id: string;data: BodyType<ListingDraftInput>}, TContext> => {

const mutationKey = ['updateListingDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateListingDraft>>, {id: string;data: BodyType<ListingDraftInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateListingDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateListingDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateListingDraft>>>
    export type UpdateListingDraftMutationBody = BodyType<ListingDraftInput>
    export type UpdateListingDraftMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a listing draft
 */
export const useUpdateListingDraft = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListingDraft>>, TError,{id: string;data: BodyType<ListingDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateListingDraft>>,
        TError,
        {id: string;data: BodyType<ListingDraftInput>},
        TContext
      > => {
      return useMutation(getUpdateListingDraftMutationOptions(options));
    }

export const getDeleteListingDraftUrl = (id: string,) => {




  return `/api/listings/drafts/${id}`
}

/**
 * Deletes a specific listing draft
 * @summary Delete a listing draft
 */
export const deleteListingDraft = async (id: string, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteListingDraftUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteListingDraftMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListingDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteListingDraft>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteListingDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteListingDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteListingDraft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListingDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteListingDraft>>>

    export type DeleteListingDraftMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a listing draft
 */
export const useDeleteListingDraft = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListingDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteListingDraft>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteListingDraftMutationOptions(options));
    }

export const getGetGuestCheckoutUrl = () => {




  return `/api/guest-checkout`
}

/**
 * Requires the opaque HttpOnly guest cookie or a registered payer token; never looks up an account by an email address.
 * @summary Read this browser's private guest checkout details
 */
export const getGuestCheckout = async ( options?: RequestInit): Promise<GetGuestCheckout200> => {

  return customFetch<GetGuestCheckout200>(getGetGuestCheckoutUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGuestCheckoutQueryKey = () => {
    return [
    `/api/guest-checkout`
    ] as const;
    }


export const getGetGuestCheckoutQueryOptions = <TData = Awaited<ReturnType<typeof getGuestCheckout>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckout>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestCheckoutQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestCheckout>>> = ({ signal }) => getGuestCheckout({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckout>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuestCheckoutQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestCheckout>>>
export type GetGuestCheckoutQueryError = ErrorType<unknown>


/**
 * @summary Read this browser's private guest checkout details
 */

export function useGetGuestCheckout<TData = Awaited<ReturnType<typeof getGuestCheckout>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckout>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGuestCheckoutQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartGuestCheckoutUrl = () => {




  return `/api/guest-checkout`
}

/**
 * Does not verify an email, adopt an existing account, create a booking or initiate payment. Existing guest cookies require the matching CSRF header.
 * @summary Provision an isolated checkout payer session
 */
export const startGuestCheckout = async (guestCheckoutDetails: GuestCheckoutDetails, options?: RequestInit): Promise<StartGuestCheckout200> => {

  return customFetch<StartGuestCheckout200>(getStartGuestCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guestCheckoutDetails)
  }
);}





export const getStartGuestCheckoutMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGuestCheckout>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startGuestCheckout>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext> => {

const mutationKey = ['startGuestCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startGuestCheckout>>, {data: BodyType<GuestCheckoutDetails>}> = (props) => {
          const {data} = props ?? {};

          return  startGuestCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartGuestCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof startGuestCheckout>>>
    export type StartGuestCheckoutMutationBody = BodyType<GuestCheckoutDetails>
    export type StartGuestCheckoutMutationError = ErrorType<void>

    /**
 * @summary Provision an isolated checkout payer session
 */
export const useStartGuestCheckout = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGuestCheckout>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startGuestCheckout>>,
        TError,
        {data: BodyType<GuestCheckoutDetails>},
        TContext
      > => {
      return useMutation(getStartGuestCheckoutMutationOptions(options));
    }

export const getUpdateGuestCheckoutDetailsUrl = () => {




  return `/api/guest-checkout`
}

/**
 * @summary Update this guest payer's unverified contact details
 */
export const updateGuestCheckoutDetails = async (guestCheckoutDetails: GuestCheckoutDetails, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateGuestCheckoutDetailsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guestCheckoutDetails)
  }
);}





export const getUpdateGuestCheckoutDetailsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestCheckoutDetails>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGuestCheckoutDetails>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext> => {

const mutationKey = ['updateGuestCheckoutDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGuestCheckoutDetails>>, {data: BodyType<GuestCheckoutDetails>}> = (props) => {
          const {data} = props ?? {};

          return  updateGuestCheckoutDetails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGuestCheckoutDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateGuestCheckoutDetails>>>
    export type UpdateGuestCheckoutDetailsMutationBody = BodyType<GuestCheckoutDetails>
    export type UpdateGuestCheckoutDetailsMutationError = ErrorType<void>

    /**
 * @summary Update this guest payer's unverified contact details
 */
export const useUpdateGuestCheckoutDetails = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGuestCheckoutDetails>>, TError,{data: BodyType<GuestCheckoutDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGuestCheckoutDetails>>,
        TError,
        {data: BodyType<GuestCheckoutDetails>},
        TContext
      > => {
      return useMutation(getUpdateGuestCheckoutDetailsMutationOptions(options));
    }

export const getSaveGuestCheckoutDraftUrl = () => {




  return `/api/guest-checkout/draft`
}

/**
 * Same-origin, bot-protected and rate-limited. Requires cookie-bound CSRF for edits. Creates no Auth account, SDK session, payment, booking or hold and never looks up an existing account by email.
 * @summary Save private checkout contact details and activate transactional recovery
 */
export const saveGuestCheckoutDraft = async (guestCheckoutDraftDetails: GuestCheckoutDraftDetails, options?: RequestInit): Promise<SaveGuestCheckoutDraft200> => {

  return customFetch<SaveGuestCheckoutDraft200>(getSaveGuestCheckoutDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guestCheckoutDraftDetails)
  }
);}





export const getSaveGuestCheckoutDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveGuestCheckoutDraft>>, TError,{data: BodyType<GuestCheckoutDraftDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveGuestCheckoutDraft>>, TError,{data: BodyType<GuestCheckoutDraftDetails>}, TContext> => {

const mutationKey = ['saveGuestCheckoutDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveGuestCheckoutDraft>>, {data: BodyType<GuestCheckoutDraftDetails>}> = (props) => {
          const {data} = props ?? {};

          return  saveGuestCheckoutDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveGuestCheckoutDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveGuestCheckoutDraft>>>
    export type SaveGuestCheckoutDraftMutationBody = BodyType<GuestCheckoutDraftDetails>
    export type SaveGuestCheckoutDraftMutationError = ErrorType<void>

    /**
 * @summary Save private checkout contact details and activate transactional recovery
 */
export const useSaveGuestCheckoutDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveGuestCheckoutDraft>>, TError,{data: BodyType<GuestCheckoutDraftDetails>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveGuestCheckoutDraft>>,
        TError,
        {data: BodyType<GuestCheckoutDraftDetails>},
        TContext
      > => {
      return useMutation(getSaveGuestCheckoutDraftMutationOptions(options));
    }

export const getEndGuestCheckoutUrl = () => {




  return `/api/guest-checkout/logout`
}

/**
 * @summary Revoke this browser's guest capability
 */
export const endGuestCheckout = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getEndGuestCheckoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEndGuestCheckoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endGuestCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endGuestCheckout>>, TError,void, TContext> => {

const mutationKey = ['endGuestCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endGuestCheckout>>, void> = () => {


          return  endGuestCheckout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndGuestCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof endGuestCheckout>>>

    export type EndGuestCheckoutMutationError = ErrorType<unknown>

    /**
 * @summary Revoke this browser's guest capability
 */
export const useEndGuestCheckout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endGuestCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof endGuestCheckout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEndGuestCheckoutMutationOptions(options));
    }

export const getClaimGuestCheckoutUrl = () => {




  return `/api/guest-checkout/claim`
}

/**
 * Requires a genuine verified account, its matching booking contact email and the guest cookie. Does not merge accounts or transfer payments.
 * @summary Associate an email-proven account with its guest booking
 */
export const claimGuestCheckout = async ( options?: RequestInit): Promise<ClaimGuestCheckout200> => {

  return customFetch<ClaimGuestCheckout200>(getClaimGuestCheckoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getClaimGuestCheckoutMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimGuestCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof claimGuestCheckout>>, TError,void, TContext> => {

const mutationKey = ['claimGuestCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimGuestCheckout>>, void> = () => {


          return  claimGuestCheckout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimGuestCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof claimGuestCheckout>>>

    export type ClaimGuestCheckoutMutationError = ErrorType<void>

    /**
 * @summary Associate an email-proven account with its guest booking
 */
export const useClaimGuestCheckout = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimGuestCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimGuestCheckout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClaimGuestCheckoutMutationOptions(options));
    }

export const getGetGuestCheckoutBookingsUrl = () => {




  return `/api/guest-checkout/bookings`
}

/**
 * @summary List only guest bookings owned by the authenticated payer or proven claimant
 */
export const getGuestCheckoutBookings = async ( options?: RequestInit): Promise<GetGuestCheckoutBookings200> => {

  return customFetch<GetGuestCheckoutBookings200>(getGetGuestCheckoutBookingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGuestCheckoutBookingsQueryKey = () => {
    return [
    `/api/guest-checkout/bookings`
    ] as const;
    }


export const getGetGuestCheckoutBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getGuestCheckoutBookings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckoutBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestCheckoutBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestCheckoutBookings>>> = ({ signal }) => getGuestCheckoutBookings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckoutBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuestCheckoutBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestCheckoutBookings>>>
export type GetGuestCheckoutBookingsQueryError = ErrorType<unknown>


/**
 * @summary List only guest bookings owned by the authenticated payer or proven claimant
 */

export function useGetGuestCheckoutBookings<TData = Awaited<ReturnType<typeof getGuestCheckoutBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuestCheckoutBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGuestCheckoutBookingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAccessGuestBookingUrl = () => {




  return `/api/guest-checkout/access`
}

/**
 * The delegated session is bound to the requesting account's current provider session. It cannot access stored cards, account changes or initialise another checkout.
 * @summary Obtain booking-only access after genuine account ownership proof
 */
export const accessGuestBooking = async (guestBookingAccessRequest: GuestBookingAccessRequest, options?: RequestInit): Promise<AccessGuestBooking200> => {

  return customFetch<AccessGuestBooking200>(getAccessGuestBookingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guestBookingAccessRequest)
  }
);}





export const getAccessGuestBookingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessGuestBooking>>, TError,{data: BodyType<GuestBookingAccessRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof accessGuestBooking>>, TError,{data: BodyType<GuestBookingAccessRequest>}, TContext> => {

const mutationKey = ['accessGuestBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessGuestBooking>>, {data: BodyType<GuestBookingAccessRequest>}> = (props) => {
          const {data} = props ?? {};

          return  accessGuestBooking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccessGuestBookingMutationResult = NonNullable<Awaited<ReturnType<typeof accessGuestBooking>>>
    export type AccessGuestBookingMutationBody = BodyType<GuestBookingAccessRequest>
    export type AccessGuestBookingMutationError = ErrorType<void>

    /**
 * @summary Obtain booking-only access after genuine account ownership proof
 */
export const useAccessGuestBooking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessGuestBooking>>, TError,{data: BodyType<GuestBookingAccessRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof accessGuestBooking>>,
        TError,
        {data: BodyType<GuestBookingAccessRequest>},
        TContext
      > => {
      return useMutation(getAccessGuestBookingMutationOptions(options));
    }

export const getGetAuthMeUrl = () => {




  return `/api/auth/me`
}

/**
 * Returns the current authenticated user. Both the web app and the mobile app rely on this exact shape.
 * @summary Get the authenticated user
 */
export const getAuthMe = async ( options?: RequestInit): Promise<AuthMeResponse> => {

  return customFetch<AuthMeResponse>(getGetAuthMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuthMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) => getAuthMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get the authenticated user
 */

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListFeaturedCarsUrl = () => {




  return `/api/cars/featured`
}

/**
 * Hero-card payload surfaced on the homepage and the mobile app's "discover" tab.
 * @summary List featured cars
 */
export const listFeaturedCars = async ( options?: RequestInit): Promise<CarsFeaturedResponse> => {

  return customFetch<CarsFeaturedResponse>(getListFeaturedCarsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFeaturedCarsQueryKey = () => {
    return [
    `/api/cars/featured`
    ] as const;
    }


export const getListFeaturedCarsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedCars>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeaturedCarsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedCars>>> = ({ signal }) => listFeaturedCars({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCars>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeaturedCarsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedCars>>>
export type ListFeaturedCarsQueryError = ErrorType<unknown>


/**
 * @summary List featured cars
 */

export function useListFeaturedCars<TData = Awaited<ReturnType<typeof listFeaturedCars>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFeaturedCarsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMostBookedNearbyCarsUrl = (params: ListMostBookedNearbyCarsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cars/most-booked-nearby?${stringifiedParams}` : `/api/cars/most-booked-nearby`
}

/**
 * Returns up to five active, pictured cars ranked by non-cancelled confirmed or completed bookings in the past 12 months. When both coordinates are supplied, the search progressively widens nearby within the requested country. When both are omitted, results are ranked across that country. A single coordinate is invalid.
 * @summary List the most-booked nearby or country-scoped cars
 */
export const listMostBookedNearbyCars = async (params: ListMostBookedNearbyCarsParams, options?: RequestInit): Promise<CarsFeaturedResponse> => {

  return customFetch<CarsFeaturedResponse>(getListMostBookedNearbyCarsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMostBookedNearbyCarsQueryKey = (params?: ListMostBookedNearbyCarsParams,) => {
    return [
    `/api/cars/most-booked-nearby`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMostBookedNearbyCarsQueryOptions = <TData = Awaited<ReturnType<typeof listMostBookedNearbyCars>>, TError = ErrorType<ErrorResponse>>(params: ListMostBookedNearbyCarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMostBookedNearbyCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMostBookedNearbyCarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMostBookedNearbyCars>>> = ({ signal }) => listMostBookedNearbyCars(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMostBookedNearbyCars>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMostBookedNearbyCarsQueryResult = NonNullable<Awaited<ReturnType<typeof listMostBookedNearbyCars>>>
export type ListMostBookedNearbyCarsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List the most-booked nearby or country-scoped cars
 */

export function useListMostBookedNearbyCars<TData = Awaited<ReturnType<typeof listMostBookedNearbyCars>>, TError = ErrorType<ErrorResponse>>(
 params: ListMostBookedNearbyCarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMostBookedNearbyCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMostBookedNearbyCarsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCarMakesUrl = () => {




  return `/api/cars/makes`
}

/**
 * Brand-picker source. Used by the listing wizard and the search filters on both surfaces.
 * @summary List car makes
 */
export const listCarMakes = async ( options?: RequestInit): Promise<CarsMakesResponse> => {

  return customFetch<CarsMakesResponse>(getListCarMakesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCarMakesQueryKey = () => {
    return [
    `/api/cars/makes`
    ] as const;
    }


export const getListCarMakesQueryOptions = <TData = Awaited<ReturnType<typeof listCarMakes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCarMakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCarMakesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCarMakes>>> = ({ signal }) => listCarMakes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCarMakes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCarMakesQueryResult = NonNullable<Awaited<ReturnType<typeof listCarMakes>>>
export type ListCarMakesQueryError = ErrorType<unknown>


/**
 * @summary List car makes
 */

export function useListCarMakes<TData = Awaited<ReturnType<typeof listCarMakes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCarMakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCarMakesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListActiveCarMakeCountsUrl = () => {




  return `/api/cars/make-counts`
}

/**
 * Returns the full active car inventory grouped by make, for use as a fallback make-picker source.
 * @summary List active car counts by make
 */
export const listActiveCarMakeCounts = async ( options?: RequestInit): Promise<CarsMakeCountsResponse> => {

  return customFetch<CarsMakeCountsResponse>(getListActiveCarMakeCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActiveCarMakeCountsQueryKey = () => {
    return [
    `/api/cars/make-counts`
    ] as const;
    }


export const getListActiveCarMakeCountsQueryOptions = <TData = Awaited<ReturnType<typeof listActiveCarMakeCounts>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActiveCarMakeCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActiveCarMakeCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveCarMakeCounts>>> = ({ signal }) => listActiveCarMakeCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActiveCarMakeCounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListActiveCarMakeCountsQueryResult = NonNullable<Awaited<ReturnType<typeof listActiveCarMakeCounts>>>
export type ListActiveCarMakeCountsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List active car counts by make
 */

export function useListActiveCarMakeCounts<TData = Awaited<ReturnType<typeof listActiveCarMakeCounts>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActiveCarMakeCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListActiveCarMakeCountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCarTypesUrl = () => {




  return `/api/cars/types`
}

/**
 * Vehicle classification taxonomy (sports, coupe, convertible, …).
 * @summary List car types
 */
export const listCarTypes = async ( options?: RequestInit): Promise<CarsTypesResponse> => {

  return customFetch<CarsTypesResponse>(getListCarTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCarTypesQueryKey = () => {
    return [
    `/api/cars/types`
    ] as const;
    }


export const getListCarTypesQueryOptions = <TData = Awaited<ReturnType<typeof listCarTypes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCarTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCarTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCarTypes>>> = ({ signal }) => listCarTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCarTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCarTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listCarTypes>>>
export type ListCarTypesQueryError = ErrorType<unknown>


/**
 * @summary List car types
 */

export function useListCarTypes<TData = Awaited<ReturnType<typeof listCarTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCarTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCarTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSearchCarsUrl = (params?: SearchCarsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["colour_id"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cars/search?${stringifiedParams}` : `/api/cars/search`
}

/**
 * Search results surfaced by both the web search page and the mobile search tab.
 * @summary Search cars
 */
export const searchCars = async (params?: SearchCarsParams, options?: RequestInit): Promise<CarsSearchResponse> => {

  return customFetch<CarsSearchResponse>(getSearchCarsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCarsQueryKey = (params?: SearchCarsParams,) => {
    return [
    `/api/cars/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCarsQueryOptions = <TData = Awaited<ReturnType<typeof searchCars>>, TError = ErrorType<unknown>>(params?: SearchCarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCars>>> = ({ signal }) => searchCars(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCars>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCarsQueryResult = NonNullable<Awaited<ReturnType<typeof searchCars>>>
export type SearchCarsQueryError = ErrorType<unknown>


/**
 * @summary Search cars
 */

export function useSearchCars<TData = Awaited<ReturnType<typeof searchCars>>, TError = ErrorType<unknown>>(
 params?: SearchCarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchCarsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRejectRetiredBookingCheckoutUrl = () => {




  return `/api/bookings`
}

/**
 * New bookings must use payment-first checkout. This endpoint never creates a trip or payment.
 * @deprecated
 * @summary Retired trip-first checkout
 */
export const rejectRetiredBookingCheckout = async ( options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getRejectRetiredBookingCheckoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRejectRetiredBookingCheckoutMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>, TError,void, TContext> => {

const mutationKey = ['rejectRetiredBookingCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>, void> = () => {


          return  rejectRetiredBookingCheckout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectRetiredBookingCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>>

    export type RejectRetiredBookingCheckoutMutationError = ErrorType<ErrorResponse>

    /**
 * @deprecated
 * @summary Retired trip-first checkout
 */
export const useRejectRetiredBookingCheckout = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectRetiredBookingCheckout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRejectRetiredBookingCheckoutMutationOptions(options));
    }

export const getListBookingsUrl = () => {




  return `/api/bookings`
}

/**
 * Trip list shown on both the web "Trips" page and the mobile "Trips" tab.
 * @summary List the authenticated user's bookings
 */
export const listBookings = async ( options?: RequestInit): Promise<BookingsListResponse> => {

  return customFetch<BookingsListResponse>(getListBookingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBookingsQueryKey = () => {
    return [
    `/api/bookings`
    ] as const;
    }


export const getListBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listBookings>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBookings>>> = ({ signal }) => listBookings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listBookings>>>
export type ListBookingsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List the authenticated user's bookings
 */

export function useListBookings<TData = Awaited<ReturnType<typeof listBookings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBookingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMessagesUrl = () => {




  return `/api/messages`
}

/**
 * Inbox conversations surfaced by both the web messages page and the mobile messages tab.
 * @summary List conversations
 */
export const listMessages = async ( options?: RequestInit): Promise<MessagesListResponse> => {

  return customFetch<MessagesListResponse>(getListMessagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagesQueryKey = () => {
    return [
    `/api/messages`
    ] as const;
    }


export const getListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessages>>> = ({ signal }) => listMessages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessages>>>
export type ListMessagesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List conversations
 */

export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMessagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInitialRequestFinancialSnapshotUrl = (tripId: number,) => {




  return `/api/bookings/${tripId}/initial-request-financial-snapshot`
}

/**
 * @summary Read the host-only originating pending-request financial snapshot
 */
export const getInitialRequestFinancialSnapshot = async (tripId: number, options?: RequestInit): Promise<GetInitialRequestFinancialSnapshot200> => {

  return customFetch<GetInitialRequestFinancialSnapshot200>(getGetInitialRequestFinancialSnapshotUrl(tripId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInitialRequestFinancialSnapshotQueryKey = (tripId: number,) => {
    return [
    `/api/bookings/${tripId}/initial-request-financial-snapshot`
    ] as const;
    }


export const getGetInitialRequestFinancialSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>, TError = ErrorType<void>>(tripId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInitialRequestFinancialSnapshotQueryKey(tripId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>> = ({ signal }) => getInitialRequestFinancialSnapshot(tripId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tripId !== null && tripId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInitialRequestFinancialSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>>
export type GetInitialRequestFinancialSnapshotQueryError = ErrorType<void>


/**
 * @summary Read the host-only originating pending-request financial snapshot
 */

export function useGetInitialRequestFinancialSnapshot<TData = Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>, TError = ErrorType<void>>(
 tripId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInitialRequestFinancialSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInitialRequestFinancialSnapshotQueryOptions(tripId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTranslatePublicListingContentUrl = () => {




  return `/api/public-content/translate`
}

/**
 * Fetches active public descriptions or published car reviews. Arbitrary caller text and private content are not accepted.
 * @summary Translate authorized public listing content by identifier
 */
export const translatePublicListingContent = async (publicContentTranslationRequest: PublicContentTranslationRequest, options?: RequestInit): Promise<PublicContentTranslation> => {

  return customFetch<PublicContentTranslation>(getTranslatePublicListingContentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicContentTranslationRequest)
  }
);}





export const getTranslatePublicListingContentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translatePublicListingContent>>, TError,{data: BodyType<PublicContentTranslationRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof translatePublicListingContent>>, TError,{data: BodyType<PublicContentTranslationRequest>}, TContext> => {

const mutationKey = ['translatePublicListingContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translatePublicListingContent>>, {data: BodyType<PublicContentTranslationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  translatePublicListingContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslatePublicListingContentMutationResult = NonNullable<Awaited<ReturnType<typeof translatePublicListingContent>>>
    export type TranslatePublicListingContentMutationBody = BodyType<PublicContentTranslationRequest>
    export type TranslatePublicListingContentMutationError = ErrorType<void>

    /**
 * @summary Translate authorized public listing content by identifier
 */
export const useTranslatePublicListingContent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translatePublicListingContent>>, TError,{data: BodyType<PublicContentTranslationRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof translatePublicListingContent>>,
        TError,
        {data: BodyType<PublicContentTranslationRequest>},
        TContext
      > => {
      return useMutation(getTranslatePublicListingContentMutationOptions(options));
    }

export const getGetSavedCarOfferConsentUrl = (carId: number,) => {




  return `/api/users/me/saved-car-offers/${carId}`
}

export const getSavedCarOfferConsent = async (carId: number, options?: RequestInit): Promise<SavedCarOfferConsent> => {

  return customFetch<SavedCarOfferConsent>(getGetSavedCarOfferConsentUrl(carId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedCarOfferConsentQueryKey = (carId: number,) => {
    return [
    `/api/users/me/saved-car-offers/${carId}`
    ] as const;
    }


export const getGetSavedCarOfferConsentQueryOptions = <TData = Awaited<ReturnType<typeof getSavedCarOfferConsent>>, TError = ErrorType<void>>(carId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedCarOfferConsent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedCarOfferConsentQueryKey(carId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedCarOfferConsent>>> = ({ signal }) => getSavedCarOfferConsent(carId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: carId !== null && carId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedCarOfferConsent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSavedCarOfferConsentQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedCarOfferConsent>>>
export type GetSavedCarOfferConsentQueryError = ErrorType<void>



export function useGetSavedCarOfferConsent<TData = Awaited<ReturnType<typeof getSavedCarOfferConsent>>, TError = ErrorType<void>>(
 carId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedCarOfferConsent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSavedCarOfferConsentQueryOptions(carId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetSavedCarOfferConsentUrl = (carId: number,) => {




  return `/api/users/me/saved-car-offers/${carId}`
}

export const setSavedCarOfferConsent = async (carId: number,
    savedCarOfferConsentRequest: SavedCarOfferConsentRequest, options?: RequestInit): Promise<SavedCarOfferConsent> => {

  return customFetch<SavedCarOfferConsent>(getSetSavedCarOfferConsentUrl(carId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedCarOfferConsentRequest)
  }
);}





export const getSetSavedCarOfferConsentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSavedCarOfferConsent>>, TError,{carId: number;data: BodyType<SavedCarOfferConsentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSavedCarOfferConsent>>, TError,{carId: number;data: BodyType<SavedCarOfferConsentRequest>}, TContext> => {

const mutationKey = ['setSavedCarOfferConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSavedCarOfferConsent>>, {carId: number;data: BodyType<SavedCarOfferConsentRequest>}> = (props) => {
          const {carId,data} = props ?? {};

          return  setSavedCarOfferConsent(carId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSavedCarOfferConsentMutationResult = NonNullable<Awaited<ReturnType<typeof setSavedCarOfferConsent>>>
    export type SetSavedCarOfferConsentMutationBody = BodyType<SavedCarOfferConsentRequest>
    export type SetSavedCarOfferConsentMutationError = ErrorType<void>

    export const useSetSavedCarOfferConsent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSavedCarOfferConsent>>, TError,{carId: number;data: BodyType<SavedCarOfferConsentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSavedCarOfferConsent>>,
        TError,
        {carId: number;data: BodyType<SavedCarOfferConsentRequest>},
        TContext
      > => {
      return useMutation(getSetSavedCarOfferConsentMutationOptions(options));
    }

export const getRevokeSavedCarOfferConsentUrl = (carId: number,) => {




  return `/api/users/me/saved-car-offers/${carId}`
}

export const revokeSavedCarOfferConsent = async (carId: number, options?: RequestInit): Promise<SavedCarOfferConsent> => {

  return customFetch<SavedCarOfferConsent>(getRevokeSavedCarOfferConsentUrl(carId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeSavedCarOfferConsentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>, TError,{carId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>, TError,{carId: number}, TContext> => {

const mutationKey = ['revokeSavedCarOfferConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>, {carId: number}> = (props) => {
          const {carId} = props ?? {};

          return  revokeSavedCarOfferConsent(carId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeSavedCarOfferConsentMutationResult = NonNullable<Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>>

    export type RevokeSavedCarOfferConsentMutationError = ErrorType<void>

    export const useRevokeSavedCarOfferConsent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>, TError,{carId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeSavedCarOfferConsent>>,
        TError,
        {carId: number},
        TContext
      > => {
      return useMutation(getRevokeSavedCarOfferConsentMutationOptions(options));
    }

export const getListSavedCarOfferInterestsUrl = (params?: ListSavedCarOfferInterestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/me/saved-car-offer-interests?${stringifiedParams}` : `/api/users/me/saved-car-offer-interests`
}

export const listSavedCarOfferInterests = async (params?: ListSavedCarOfferInterestsParams, options?: RequestInit): Promise<ListSavedCarOfferInterests200> => {

  return customFetch<ListSavedCarOfferInterests200>(getListSavedCarOfferInterestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedCarOfferInterestsQueryKey = (params?: ListSavedCarOfferInterestsParams,) => {
    return [
    `/api/users/me/saved-car-offer-interests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSavedCarOfferInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listSavedCarOfferInterests>>, TError = ErrorType<void>>(params?: ListSavedCarOfferInterestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSavedCarOfferInterests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedCarOfferInterestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedCarOfferInterests>>> = ({ signal }) => listSavedCarOfferInterests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedCarOfferInterests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSavedCarOfferInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedCarOfferInterests>>>
export type ListSavedCarOfferInterestsQueryError = ErrorType<void>



export function useListSavedCarOfferInterests<TData = Awaited<ReturnType<typeof listSavedCarOfferInterests>>, TError = ErrorType<void>>(
 params?: ListSavedCarOfferInterestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSavedCarOfferInterests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSavedCarOfferInterestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendSavedCarOfferUrl = (consentId: string,) => {




  return `/api/users/me/saved-car-offer-interests/${consentId}/send`
}

export const sendSavedCarOffer = async (consentId: string,
    savedCarOfferSendRequest: SavedCarOfferSendRequest, options?: RequestInit): Promise<SendSavedCarOffer200> => {

  return customFetch<SendSavedCarOffer200>(getSendSavedCarOfferUrl(consentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(savedCarOfferSendRequest)
  }
);}





export const getSendSavedCarOfferMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSavedCarOffer>>, TError,{consentId: string;data: BodyType<SavedCarOfferSendRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSavedCarOffer>>, TError,{consentId: string;data: BodyType<SavedCarOfferSendRequest>}, TContext> => {

const mutationKey = ['sendSavedCarOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSavedCarOffer>>, {consentId: string;data: BodyType<SavedCarOfferSendRequest>}> = (props) => {
          const {consentId,data} = props ?? {};

          return  sendSavedCarOffer(consentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSavedCarOfferMutationResult = NonNullable<Awaited<ReturnType<typeof sendSavedCarOffer>>>
    export type SendSavedCarOfferMutationBody = BodyType<SavedCarOfferSendRequest>
    export type SendSavedCarOfferMutationError = ErrorType<void>

    export const useSendSavedCarOffer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSavedCarOffer>>, TError,{consentId: string;data: BodyType<SavedCarOfferSendRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSavedCarOffer>>,
        TError,
        {consentId: string;data: BodyType<SavedCarOfferSendRequest>},
        TContext
      > => {
      return useMutation(getSendSavedCarOfferMutationOptions(options));
    }
